var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "global-modals" },
    [
      _c("MeusDados", { attrs: { bus: _vm.GlobalBus } }),
      _c("ModalExtensionToken"),
      _c("ModalWhatsappConectar"),
      _c("ModalCarteiraRecomendada"),
      _c("ModalSelecionarCarteiraRecomendada"),
      _c("ModalContactWhitelabel"),
      _c("ModalAlterarSenha"),
      _c("ModalSelecionarCliente", { attrs: { bus: _vm.GlobalBus } }),
      _c("ModalAddPortfolioModelo"),
      _c("ModalOpenClient"),
      _c("ModalIPS"),
      _c("ModalChangeClass"),
      _c("ModalIPSAnswerClient"),
      _c("ModalEditObservation"),
      _c("ModalOpcoes"),
      _c("SuggestImprovement", { attrs: { bus: _vm.GlobalBus } }),
      _c("ModalProduto"),
      _c("ModalAcesso"),
      _c("ModalExportAccessClients"),
      _c("ModalImportAccessClients"),
      _c("ModalImportBaseAtivos"),
      _c("ModalCotasHistoricas"),
      _c("ModalVincularAtivoEscolher"),
      _c("ModalRegisterAsset"),
      _c("ModalAddInvestmentAccount"),
      _c("ModalAporteResgate", { attrs: { bus: _vm.GlobalBus } }),
      _c("GlobalSearch"),
      _c("IaPalette"),
      _c("AiFrameworkCreditosModal"),
      _c("AtalhoIaImersiva"),
      _c("ModalCadastroClientes"),
      _c("ModalRemoveLinkedAccounts"),
      _c("ModalAssinaturaProfissional"),
      _c("ModalSeeProspect"),
      _c("ModalEnviarEmail"),
      _c("ModalPagarmeResgatar"),
      _c("ModalPagarmeHistorico"),
      _c("ModalPagarmeCobrancaDetalhes"),
      _c("ModalAddBankAccount"),
      _c("ModalAddBenchmark"),
      _c("ModalChangeCard"),
      _c("ModalPortabilidade"),
      _c("ModalVincularConta"),
      _c("ModalDadosPagamento"),
      _c("ModalResumo"),
      _c("ModalCreateRoom"),
      _c("ModalCreateTemplate"),
      _c("ModalSelectTemplate"),
      _c("ModalCarteiraData"),
      _c("ModalSelecionarModeloPDF"),
      _c("ModalSelecionarModeloPDFCliente"),
      _c("ModalConsentirCrawlerDiario"),
      _c("ModalExportarExtrato"),
      _c("ModalImportarExtrato"),
      _c("ModalComposicaoFundo"),
      _c("ModalSaveFeeModel"),
      _c("ModalBatchFeeModel"),
      _c("ModalMarkFeePaid"),
      _c("ModalTeams"),
      _c("ModalNewProfessional"),
      _c("ModalProfessionalChurnList"),
      _c("ModalProfessionalChurnRegister"),
      _c("ModalBenchmarkComposition"),
      _c("ModalDownloadDre"),
      _c("ModalFinanceDetailsComissionCategory"),
      _c("ModalCalendarConfirmFinishTask"),
      _c("ModalCreateCalendar"),
      _c("AvatarUploadModal"),
      _c("AawzDriveRenameFile"),
      _c("CrmLeadPerdaModal"),
      _c("CrmMotivoPerdaModal"),
      _c("IntelligenceV2FolderCreate"),
      _c("IntelligenceV2FolderRename"),
      _c("IaSuggestionsModal"),
      _c("SuggestionEdit"),
      _c("SuggestionDecline"),
      _c("AdvisoryDecisaoModal"),
      _c("IntelligenceV2ConectarEmailAgenda"),
      _c("IntelligenceV2ConectarWhatsapp"),
      _c("IntelligenceV2ConectarWhatsappQrcode"),
      _c("CrmLeadSteps"),
      _c("CrmRegisterRelationshipModal"),
      _c("TranscriptDetailModal"),
      _c("ModalCrmOpportunities", { ref: "modalCrmOpportunities" }),
      _c("CrmOportunidadePerdaModal"),
      _c("CrmScheduleTaskCalendar", { ref: "crmScheduleTaskCalendar" }),
      _c("ModalCRMAddNewLead", { ref: "modalCRMAddNewLead" }),
      _c("ModalCRMAddClient", { ref: "modalCRMAddClient" }),
      _c("CrmImportLeadsBatch", { ref: "crmImportLeadsBatch" }),
      _c("TranscriptProjectModal", { ref: "transcriptProjectModal" }),
      _c("TaskDetailModal", { ref: "taskDetailModal" }),
      _c("SolicitacaoAvisoConclusaoModal"),
      _c("CrmEditFieldModal"),
      _c("ModalEditValueTime"),
      _c("ModalClientReguaLink"),
      _c("CrmEditFeeModel"),
      _c("CrmEditDatetime"),
      _c("SummaryLayoutForm"),
      _c("CrmCommentModal"),
      _c("CampoObrigatorioPicker"),
      _c("CrmRequiredFieldsModal"),
      _c("CrmEvolucaoAmpliarModal"),
      _c("CrmRegisterRelationshipResultModal")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }